/**
** JAVASCRIPTS
** Name: Video btn
********************************************************************************/

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".c-video");

  videos.forEach((video) => {
    const wrapper = video.querySelector(".c-video__wrapper");
    const button = video.querySelector(".c-video__button");
    const figure = video.querySelector(".c-video__figure");

    if (!wrapper) return;

    const YOUTUBE_IFRAME_SELECTOR =
      'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"], iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]';

    const showVideo = () => {
      if (button) button.remove();
      if (figure) figure.remove();
      video.classList.remove("c-video--notplay");
    };

    const isYoutubeAllowed = () => {
      return true;

      try {
        if (!window.Didomi) return true;

        const status = window.Didomi.getCurrentUserStatus();
        const vendor = status?.vendors?.youtube;

        if (vendor?.enabled === true || vendor?.consent === true) {
          return true;
        }

        if (window.Didomi.shouldUserStatusBeCollected() === false) {
          const purposes = Object.values(status?.purposes || {});
          return purposes.length > 0 && purposes.some((p) => p.enabled === true);
        }

        return false;
      } catch (e) {
        return false;
      }
    };

    const enableYoutubeConsent = () => {
      try {
        const vendor = window.Didomi?.getVendorById("youtube");
        if (!vendor) return;

        const transaction = window.Didomi.openCurrentUserStatusTransaction();
        transaction.enableVendor(vendor.didomiId);
        transaction.enablePurposes(vendor.purposeIds);
        transaction.commit();
      } catch (e) {}
    };

    const withAutoplay = (rawUrl) => {
      try {
        const url = new URL(rawUrl, window.location.href);
        url.searchParams.set("autoplay", "1");
        url.searchParams.set("rel", "0");
        return url.toString();
      } catch (e) {
        return rawUrl;
      }
    };

    const buildYoutubeIframe = ({ src, width, height, title, className, style, loading, allow }) => {
      const iframe = document.createElement("iframe");

      if (width) iframe.setAttribute("width", width);
      if (height) iframe.setAttribute("height", height);
      if (title) iframe.setAttribute("title", title);
      if (className) iframe.setAttribute("class", className);
      if (style) iframe.setAttribute("style", style);
      if (loading) iframe.setAttribute("loading", loading);

      iframe.setAttribute("title", title || "YouTube video player");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute(
        "allow",
        allow ||
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      );
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");

      iframe.src = withAutoplay(src);

      return iframe;
    };

    const replaceWithFreshIframe = (oldIframe, rawUrl) => {
      if (!oldIframe || !rawUrl) return false;

      const freshIframe = buildYoutubeIframe({
        src: rawUrl,
        width: oldIframe.getAttribute("width"),
        height: oldIframe.getAttribute("height"),
        title: oldIframe.getAttribute("title"),
        className: oldIframe.getAttribute("class"),
        style: oldIframe.getAttribute("style"),
        loading: oldIframe.getAttribute("loading"),
        allow: oldIframe.getAttribute("allow")
      });

      oldIframe.replaceWith(freshIframe);
      return true;
    };

    const findYoutubeIframe = () => wrapper.querySelector(YOUTUBE_IFRAME_SELECTOR);

    const findBlockedYoutubeIframe = () =>
      wrapper.querySelector(
        'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]'
      );

    const findLoadedYoutubeIframe = () =>
      wrapper.querySelector(
        'iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]'
      );

    const loadBlockedIframe = () => {
      const blockedIframe = findBlockedYoutubeIframe();
      if (!blockedIframe) return false;

      const dataSrc = blockedIframe.getAttribute("data-src");
      return replaceWithFreshIframe(blockedIframe, dataSrc);
    };

    const restartExistingIframe = () => {
      const existingIframe = findLoadedYoutubeIframe();
      if (!existingIframe) return false;

      return replaceWithFreshIframe(existingIframe, existingIframe.getAttribute("src"));
    };

    const createIframeFromPlaceholder = () => {
      const placeholder = wrapper.querySelector(".youtube_player, .tac_video_player");
      if (!placeholder) return false;

      const videoID =
        placeholder.getAttribute("videoid") ||
        placeholder.getAttribute("videoID");

      if (!videoID) return false;

      const iframe = buildYoutubeIframe({
        src: `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoID)}?autoplay=1&rel=0`
      });

      placeholder.replaceWith(iframe);
      return true;
    };

    const createIframeFromLink = () => {
      const link = wrapper.querySelector('a[href*="youtube.com"], a[href*="youtube-nocookie.com"]');
      if (!link) return false;

      let videoId = null;
      try {
        const url = new URL(link.getAttribute("href"));
        videoId = url.pathname.includes("/embed/")
          ? url.pathname.split("/embed/")[1].split("?")[0]
          : url.searchParams.get("v");
      } catch (e) {
        return false;
      }

      if (!videoId) return false;

      const iframe = buildYoutubeIframe({
        src: `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`
      });

      const embedContainer = link.closest(".c-figure__embed");
      if (embedContainer) {
        embedContainer.replaceWith(iframe);
      } else {
        link.replaceWith(iframe);
      }

      return true;
    };

    const observeInjectedIframe = () => {
      const observer = new MutationObserver(() => {
        const injectedIframe = findYoutubeIframe();
        if (!injectedIframe) return;

        const rawUrl =
          injectedIframe.getAttribute("src") ||
          injectedIframe.getAttribute("data-src");

        if (!rawUrl) return;

        replaceWithFreshIframe(injectedIframe, rawUrl);
        observer.disconnect();
      });

      observer.observe(wrapper, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    };

    const startVideo = () => {
      const blockedIframe = findBlockedYoutubeIframe();
      const youtubeLink = wrapper.querySelector('a[href*="youtube.com"], a[href*="youtube-nocookie.com"]');

      if (blockedIframe || youtubeLink) {
        const loadYoutube = () => {
          enableYoutubeConsent();
          showVideo();
          if (blockedIframe) {
            loadBlockedIframe();
          } else {
            createIframeFromLink();
          }
        };

        if (isYoutubeAllowed()) {
          loadYoutube();
          return;
        }

        if (window.Didomi) window.Didomi.preferences.show();

        const poll = setInterval(() => {
          if (isYoutubeAllowed()) {
            clearInterval(poll);
            loadYoutube();
          }
        }, 500);

        setTimeout(() => clearInterval(poll), 120000);
        return;
      }

      showVideo();

      if (restartExistingIframe()) return;
      if (createIframeFromPlaceholder()) return;

      observeInjectedIframe();
    };

    if (button) button.addEventListener("click", startVideo);
    if (figure) figure.addEventListener("click", startVideo);
  });
});
